module.exports = __webpack_public_path__ + "img/video-cover-visual-design.552bed49.jpg";